module.exports = __webpack_public_path__ + "static/fonts/HelveticaNeueCyr-Bold.b213a12.ttf";